import script from "./promotionPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./promotionPage.vue?vue&type=script&setup=true&lang=ts"

import "./promotionPage.vue?vue&type=style&index=0&id=1042d35e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1042d35e"]])

export default __exports__